module.exports = __webpack_public_path__ + "img/bianzu3.2c716a76.png";